import { render } from "./Channels.vue?vue&type=template&id=b880f358&scoped=true&bindings={\"config\":\"setup\",\"channelsLoading\":\"setup\",\"sortedChannels\":\"setup\",\"filteredChannels\":\"setup\",\"maxWidth\":\"setup\",\"responsiveClass\":\"setup\",\"titles\":\"setup\",\"toggleConfigKey\":\"setup\"}"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"

import "./Channels.vue?vue&type=style&index=0&id=b880f358&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b880f358"

export default script